





import { Component, Prop, Vue } from 'vue-property-decorator';
import { IMentoringNumberIcon } from './types';

@Component
export default class MentoringNumberIcon extends Vue
  implements IMentoringNumberIcon {
  @Prop({ type: [Number, String], default: 1 })
  readonly number!: string | number;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/process/components/number/components/numbericon/MentoringNumberIcon.vue